<template>
	<figure class="allocation-breakdown-wheel position-relative mx-0">
		<highcharts :options="chartOptions" :highcharts="localHc" class="highcharts-container" />
	</figure>
</template>
<script setup lang="ts">
import Highcharts, { Options } from 'highcharts';
import BaseChart from '@charts/BaseChartOptions';
import { computed } from 'vue';
import deepMerge from 'deepmerge';
import { Chart as highcharts } from 'highcharts-vue';

interface Props {
	percentage: string;
}

const props = defineProps<Props>();

const localHc = Highcharts;

const chartOptions = computed((): Options => {
	const percentNum = parseInt(props.percentage);
	const localOptions = {
		chart: {
			type: 'pie',
			spacing: [0, 0, 0, 0],
			height: '24',
			width: '24'
		},
		plotOptions: {
			animation: false,
			pie: {
				borderWidth: 0,
				innerSize: '65%',
				size: '24',
				states: {
					hover: {
						enabled: false
					},
					inactive: {
						enabled: false
					}
				}
			}
		},
		series: [
			{
				type: 'pie',
				data: [
					{
						y: percentNum,
						color: '#151513'
					},
					{
						y: 100 - percentNum,
						color: '#d9d9d9'
					}
				]
			}
		]
	};

	return deepMerge(new BaseChart().getOptions(), localOptions);
});
</script>
<style lang="scss" scoped>
.allocation-breakdown-wheel {
	margin-top: -6px;
	margin-bottom: 0;
}
</style>
